import Grid from '@material-ui/core/Grid';
import Checkbox from '@mui/material/Checkbox';
import { useEffect, useState, memo } from 'react';


const SangerRowPremix = memo((props) => {
    const data = props.data;
    const updateSample = props.updateSample
  
  return (
    <Grid item>
      <Checkbox
        checked={data.premixed}
        style={{paddingBottom: 0}}
        onChange={(e) => {
          let newPrimerRowList = [...data.primerRowList];
          if (e.target.checked) {
            newPrimerRowList = []
          }
          updateSample({ premixed: e.target.checked, primerRowList: newPrimerRowList }, props.id);
        }}
        >
      </Checkbox>
    </Grid>
    );
},
(prevProps, nextProps) => {
    return prevProps.id === nextProps.id && prevProps.data.premixed === nextProps.data.premixed;
});

export default SangerRowPremix;